export function typesSelector(state) {
    return state.types
}
 